import styled from 'styled-components'
import success from './success.svg'

export const Success = styled.div`
  display: block;
  width: 100%;
  height: 120px;
  margin-top: 100px;
  margin-bottom: 30px;
  
  background:url(${success}) no-repeat center;
`



// WEBPACK FOOTER //
// ./src/atoms/Success/index.tsx